<template>
    <div id="app" :style="myStyle">
        <div v-html="page"></div>
    </div>
</template>

<script>

import discover from '@/services/discover'

export default {
    data() {
        return{
            page: '',
            myStyle:{}
        }
    },
    mounted(){
        this.loadData()
    },
    methods: {
        loadData(){
            if(this.$route.query.id){
                discover.getDiscoverWebView(this.$route.query.id)
                .then(res => {
                    this.page = res.data.rich_text;

                }).catch ((err) => {
                    alert(err.response.data.message);
                })
            }

            this.myStyle = {backgroundColor: "#" + this.$route.query.bgcolor};
        }
    }
}
</script>
<style>
body {
  height: 100vh;
  margin: 0;
  padding: 0px;

  width: 100%;
}
#app {
  display: flex;
  height: 100%;
}
</style>